import * as tslib_1 from "tslib";
import Vue from "vue";
import { runExpr } from "expr";
import { padLeft } from "vue-ext";
import axios from "axios";
var State = /** @class */ (function () {
    function State() {
        this.mode = "worktop";
        this.proshop = false;
        this.store = false;
        this.fusion = false;
        this.prodlib = false;
        this.vertex = false;
        this.disableAccessories = false;
        this.isProshopUser = false;
        this.disabledWorktopLocation = false;
        this.worktopWidth = null;
        this.worktopHeight = null;
        this.worktopLength = null;
        this.worktopLocationCode = null;
        this.backpanelStructure = null;
        this.backpanelLength = null;
        this.backpanelHeight = null;
        this.edgeProfileCode = null;
        this.material = null;
        this.graphics = null;
        this.sink = null;
        this.sinkHandedness = null;
        this.sinkOrientation = null;
        this.m1Structure = "0";
        //Distance to the edge of the worktop from the handedness side
        //Left handed sink = sinkDistanceX is from left side
        this.sinkDistanceX = null;
        this.sinkDistanceMeasuredTo = "edge";
        this.hobcutoutDistanceMeasuredTo = "edge";
        this.hobcutout = null;
        this.hobcutoutCornerRadius = "0";
        this.hobcutoutLength = null;
        this.hobcutoutWidth = null;
        this.hobcutoutDistanceY = null;
        this.hobcutoutDistanceX = null;
        this.faucetHole = "0";
        this.extraHole = "0";
        this.extraHole2 = "0";
        this.accessories = [];
        this.dirty = false;
    }
    Object.defineProperty(State.prototype, "externalEmbed", {
        get: function () {
            return this.fusion || this.vertex || this.store || this.prodlib;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "worktopLocation", {
        get: function () {
            return this.disabledWorktopLocation
                ? "Island"
                : this.worktopLocationCode;
        },
        set: function (value) {
            if (this.disabledWorktopLocation)
                return;
            this.worktopLocationCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "backpanelReservedCode", {
        get: function () { return "X"; },
        set: function (value) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "backpanelReservedCode2", {
        get: function () { return "X"; },
        set: function (value) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "trap", {
        get: function () {
            var noTrapCode = this.sink && this.sink != "H" ? "0" : "X";
            return this.accessories.indexOf("trap") >= 0 ? "V" : noTrapCode;
        },
        set: function (value) {
            var index = this.accessories.indexOf("trap");
            if (value == "V") {
                if (index < 0) {
                    this.accessories.push("trap");
                }
            }
            else {
                if (index >= 0)
                    this.accessories.splice(index, 1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "edgeProfile", {
        get: function () {
            var edgeProfileCodes = this.worktopLocation == "Island" ? ["B", "A"] : ["-", "S"];
            return edgeProfileCodes[this.edgeProfileCode == "Raised" ? 0 : 1];
        },
        set: function (value) {
            if (!value) {
                this.edgeProfileCode = null;
                this.worktopLocation = null;
                return;
            }
            this.edgeProfileCode = (value == "-" || value == "B" ? "Raised" : "Straight");
            this.worktopLocation = (value == "-" || value == "S" ? "AgainstWall" : "Island");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "faucetHoleCode", {
        get: function () {
            return this.faucetHole;
        },
        set: function (value) {
            this.faucetHole = !value ? "0" : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "extraHoleCode", {
        get: function () {
            if (this.extraHole && this.extraHole != "0" && this.extraHole2 && this.extraHole2 != "0")
                return "H";
            if (this.extraHole != "0")
                return this.extraHole;
            return this.extraHole2;
        },
        set: function (hole) {
            if (!hole) {
                this.extraHole = "0";
                this.extraHole2 = "0";
                return;
            }
            if (hole == "H") {
                this.extraHole = "L";
                this.extraHole2 = "R";
                return;
            }
            this.extraHole = hole;
            this.extraHole2 = "0";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "defaults", {
        //Contains default values for designer code generation
        //Do not mix up with actual default values in the UI
        get: function () {
            return {
                faucetHoleCode: "0",
                extraHoleCode: "0",
                material: "0",
                sinkDistanceX: "0000",
                trap: "0",
                hobcutout: "0",
                hobcutoutLength: "0000",
                hobcutoutWidth: "000",
                hobcutoutCornerRadius: "0",
                hobcutoutDistanceX: "0000",
                hobcutoutDistanceY: "00",
                m1Structure: "0",
                graphics: "00"
            };
        },
        enumerable: true,
        configurable: true
    });
    return State;
}());
export { State };
var Cart = /** @class */ (function () {
    function Cart(state, ui, config) {
        this.state = state;
        this.ui = ui;
        this.config = config;
        this.products = [];
        this.cartProducts = [];
        this.planCode = null;
        this.populateSummary();
    }
    Object.defineProperty(Cart.prototype, "productCount", {
        get: function () {
            return Math.max(this.products.length, this.cartProducts.length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "numberOfDecimals", {
        get: function () {
            return this.ui.language == "sv" || this.ui.language == "nb"
                ? 0
                : 2;
        },
        enumerable: true,
        configurable: true
    });
    Cart.prototype.populateSummary = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product, additionalCostProductcodes, productsWithoutAdditionalCost, plan;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.products = [];
                        this.planCode = null;
                        if (this.state.mode != '' &&
                            ((!this.isCurrentCodeValidWorktopCode && !this.isCurrentCodeValidBackpanelCode) ||
                                (this.isCurrentCodeValidWorktopCode && (this.ui.sinkHasPlacementError || !this.ui.sinkIsValid || this.ui.hobcutoutIsInvalid || this.ui.hobcutoutHasPlacementError)))) {
                            this.products = this.cartProducts;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getCurrentCartProduct()];
                    case 1:
                        product = _a.sent();
                        if (product != null) {
                            this.products.push(product);
                        }
                        return [4 /*yield*/, this.setAdditionalCostProducts()];
                    case 2:
                        _a.sent();
                        additionalCostProductcodes = this.config.conditionalAdditionalCostProducts
                            ? this.config.conditionalAdditionalCostProducts.map(function (p) { return p.code; })
                            : null;
                        this.products = this.cartProducts.concat(this.products);
                        productsWithoutAdditionalCost = this.products.filter(function (p) { return additionalCostProductcodes == null || additionalCostProductcodes.indexOf(p.code) < 0; });
                        if (!(this.cartProducts.length == 0 && this.state.accessories.length == 0 && this.products.length < 2)) return [3 /*break*/, 3];
                        this.planCode = this.currentDesignerCode;
                        return [3 /*break*/, 6];
                    case 3:
                        if (!((productsWithoutAdditionalCost.length == 1 && this.products[0].accessories.length == 0) || this.state.vertex)) return [3 /*break*/, 4];
                        this.planCode = this.products[0].code;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.createPlan()];
                    case 5:
                        plan = _a.sent();
                        this.planCode = plan.code;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.addCurrentDesignToCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentCartProduct()];
                    case 1:
                        product = _a.sent();
                        if (product != null) {
                            product.removable = true;
                            if (product.accessories)
                                product.accessories.forEach(function (a) { return a.removable = true; });
                            this.cartProducts.push(product);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Cart.prototype, "hasBackpanelsInCart", {
        get: function () {
            var _this = this;
            return this.products && this.products.filter(function (p) { return _this.isValidBackpanelCode(p.code); }).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Cart.prototype.resetCart = function () {
        this.cartProducts = [];
    };
    Cart.prototype.resetState = function () {
        var e_1, _a;
        var properties = tslib_1.__spread(this.codeProperties, this.backpanelCodeProperties);
        try {
            for (var properties_1 = tslib_1.__values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                var prop = properties_1_1.value;
                this.state[prop] = null;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.state.dirty = this.cartProducts.length > 0;
        this.state.accessories = [];
        //this.products = [];
    };
    Cart.prototype.getPlan = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("GetPlan?planCode=" + code)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Cart.prototype.createPlan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var additionalCostProductcodes, productsWithoutAdditionalCost, products, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalCostProductcodes = this.config.conditionalAdditionalCostProducts
                            ? this.config.conditionalAdditionalCostProducts.map(function (p) { return p.code; })
                            : null;
                        productsWithoutAdditionalCost = this.products.filter(function (p) { return additionalCostProductcodes == null || additionalCostProductcodes.indexOf(p.code) < 0; });
                        products = productsWithoutAdditionalCost.map(function (p) {
                            return {
                                code: p.code,
                                accessories: p.accessories.filter(function (a) { return a.code; }).map(function (a) { return a.code; })
                            };
                        });
                        return [4 /*yield*/, axios.post("CreatePlan", {
                                products: products
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Cart.prototype.removeProductFromCart = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var index;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = this.cartProducts.indexOf(product);
                        if (!(index == -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cancelCurrentDesign()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.cartProducts.splice(index, 1);
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.populateSummary()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.removeAccessoryProductFromCart = function (product, accessory) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var index, index;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.cartProducts.indexOf(product) == -1) {
                            index = this.state.accessories.indexOf(accessory.code);
                            this.state.accessories.splice(index, 1);
                        }
                        else {
                            index = product.accessories.indexOf(accessory);
                            product.accessories.splice(index, 1);
                        }
                        return [4 /*yield*/, this.populateSummary()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.refreshCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, e_3, _b, _c, _d, product, data, _loop_1, this_1, _e, _f, accessory, e_3_1, e_2_1;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 12, 13, 14]);
                        _c = tslib_1.__values(this.products), _d = _c.next();
                        _g.label = 1;
                    case 1:
                        if (!!_d.done) return [3 /*break*/, 11];
                        product = _d.value;
                        return [4 /*yield*/, axios.get("GetPrice?code=" + product.code + "&language=" + this.ui.language)];
                    case 2:
                        data = (_g.sent()).data;
                        product.price = data.price;
                        if (!(product.accessories && product.accessories.length > 0)) return [3 /*break*/, 10];
                        _loop_1 = function (accessory) {
                            var data_1, accessoryModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, axios.get("GetPrice?code=" + accessory.code + "&language=" + this_1.ui.language)];
                                    case 1:
                                        data_1 = (_a.sent()).data;
                                        accessoryModel = this_1.config.models.accessories.find(function (a) { return a.code == accessory.code; });
                                        accessory.price = data_1.price;
                                        accessory.name = accessoryModel.name;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _g.label = 3;
                    case 3:
                        _g.trys.push([3, 8, 9, 10]);
                        _e = tslib_1.__values(product.accessories), _f = _e.next();
                        _g.label = 4;
                    case 4:
                        if (!!_f.done) return [3 /*break*/, 7];
                        accessory = _f.value;
                        return [5 /*yield**/, _loop_1(accessory)];
                    case 5:
                        _g.sent();
                        _g.label = 6;
                    case 6:
                        _f = _e.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_3_1 = _g.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        _d = _c.next();
                        return [3 /*break*/, 1];
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 14];
                    case 13:
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.addPlanProductToCart = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, values, properties, tempState, accessories, isBackpanelProduct, i, property, value, data, _b, _c, accessory, accessoryModel, data_2, e_4_1, cartProduct, sinks, sink, worktopWidth, worktopHeight;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        values = [];
                        properties = [];
                        tempState = {};
                        accessories = [];
                        isBackpanelProduct = false;
                        if (this.isValidWorktopCode(product.designerCode)) {
                            values = this.designerCodeRegex.exec(product.designerCode);
                            properties = this.codeProperties;
                        }
                        else if (this.isValidBackpanelCode(product.designerCode)) {
                            values = this.backpanelCodeRegex.exec(product.designerCode);
                            properties = this.backpanelCodeProperties;
                            isBackpanelProduct = true;
                        }
                        values.splice(0, 1); //First item is the full match, don't need it
                        if (!values || values.length <= 0)
                            return [2 /*return*/];
                        for (i = 0; i < values.length; i++) {
                            property = properties[i];
                            value = values[i];
                            tempState[property] = value;
                        }
                        return [4 /*yield*/, axios.get("GetPrice?code=" + product.designerCode + "&language=" + this.ui.language)];
                    case 1:
                        data = (_d.sent()).data;
                        if (!(product.accessories && product.accessories.length > 0)) return [3 /*break*/, 9];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 7, 8, 9]);
                        _b = tslib_1.__values(product.accessories.split(",")), _c = _b.next();
                        _d.label = 3;
                    case 3:
                        if (!!_c.done) return [3 /*break*/, 6];
                        accessory = _c.value;
                        accessoryModel = this.config.models.accessories.find(function (a) { return a.code == accessory; });
                        if (accessoryModel == null)
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, axios.get("GetPrice?code=" + accessory + "&language=" + this.ui.language)];
                    case 4:
                        data_2 = (_d.sent()).data;
                        accessories.push({
                            name: accessoryModel.name,
                            dimensions: null,
                            code: accessoryModel.code,
                            price: data_2.price,
                            removable: true,
                            accessories: null
                        });
                        _d.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_4_1 = _d.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        cartProduct = {
                            name: null,
                            removable: true,
                            dimensions: null,
                            code: product.designerCode,
                            price: data.price,
                            accessories: accessories
                        };
                        if (isBackpanelProduct) {
                            cartProduct.name = this.ui.t("backpanel") + " " + tempState["backpanelStructure"];
                            cartProduct.dimensions = parseInt(tempState["backpanelLength"]) + "x" + parseInt(tempState["backpanelHeight"]);
                        }
                        else {
                            sinks = this.config.models.sinks.filter(function (s) { return s.code == tempState["sink"]; });
                            sink = sinks.find(function (s) { return s.handedness == tempState["sinkHandedness"]; }) || sinks[0];
                            worktopWidth = this.config.models.worktopWidths.find(function (s) { return s.code == tempState["worktopWidth"]; });
                            worktopHeight = this.config.models.worktopHeights.find(function (s) { return s.code == tempState["worktopHeight"]; });
                            cartProduct.name = sink.name;
                            cartProduct.dimensions = tempState["worktopLength"] + "x" + worktopWidth.width + "x" + worktopHeight.height;
                        }
                        this.cartProducts.push(cartProduct);
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.setAdditionalCostProducts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, _loop_2, this_2, _b, _c, conditionalProduct, e_5_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.config.conditionalAdditionalCostProducts)
                            return [2 /*return*/];
                        _loop_2 = function (conditionalProduct) {
                            var condition, productsWithAdditionalCost, data;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        condition = new RegExp(conditionalProduct.condition);
                                        productsWithAdditionalCost = this_2.products.concat(this_2.cartProducts).filter(function (p) { return condition.test(p.code); });
                                        if (!(productsWithAdditionalCost.length > 0)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, axios.get("GetPrice", { params: { code: conditionalProduct.code, language: this_2.ui.language, quantity: productsWithAdditionalCost.length } })];
                                    case 1:
                                        data = (_a.sent()).data;
                                        this_2.products.push({
                                            name: conditionalProduct.name,
                                            removable: false,
                                            dimensions: null,
                                            code: conditionalProduct.code,
                                            price: data.price,
                                            accessories: []
                                        });
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_2 = this;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(this.config.conditionalAdditionalCostProducts), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        conditionalProduct = _c.value;
                        return [5 /*yield**/, _loop_2(conditionalProduct)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_5_1 = _d.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.getCurrentCartProduct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6, _a, accessories, _b, _c, accessory, accessoryConfig, accessoryModel, data, e_6_1, product, data;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.state.mode == '')
                            return [2 /*return*/, null];
                        accessories = [];
                        if (!(this.state.accessories.length > 0)) return [3 /*break*/, 9];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, 8, 9]);
                        _b = tslib_1.__values(this.state.accessories), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 6];
                        accessory = _c.value;
                        accessoryConfig = this.config.models.accessories.find(function (a) { return a.code == accessory; });
                        if (accessoryConfig == null)
                            return [3 /*break*/, 5];
                        accessoryModel = {
                            name: accessoryConfig.name,
                            dimensions: null,
                            removable: true,
                            price: null,
                            code: accessoryConfig.code,
                            accessories: null
                        };
                        if (!!this.ui.hidePrices) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios.get("GetPrice?code=" + accessory + "&language=" + this.ui.language)];
                    case 3:
                        data = (_d.sent()).data;
                        accessoryModel.price = data.price;
                        _d.label = 4;
                    case 4:
                        accessories.push(accessoryModel);
                        _d.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        product = {
                            code: this.currentDesignerCode,
                            price: null,
                            name: null,
                            dimensions: null,
                            removable: true,
                            accessories: accessories
                        };
                        if (this.isValidWorktopCode(this.currentDesignerCode)) {
                            product.name = this.ui.sink.name;
                            product.dimensions = this.ui.worktopLength + "x" + this.ui.worktopWidth + "x" + this.ui.worktopHeight;
                        }
                        else if (this.isValidBackpanelCode(this.currentDesignerCode)) {
                            product.name = this.ui.t("backpanel") + " " + this.state.backpanelStructure;
                            product.dimensions = this.ui.backpanelLength + "x" + this.ui.backpanelHeight;
                        }
                        if (!!this.ui.hidePrices) return [3 /*break*/, 11];
                        return [4 /*yield*/, axios.get("GetPrice?code=" + this.currentDesignerCode + "&language=" + this.ui.language)];
                    case 10:
                        data = (_d.sent()).data;
                        product.price = data.price;
                        _d.label = 11;
                    case 11: return [2 /*return*/, product];
                }
            });
        });
    };
    Object.defineProperty(Cart.prototype, "currencyCode", {
        get: function () {
            return this.config.currencyCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "taxPercent", {
        get: function () {
            return this.config.taxPercent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "priceSummary", {
        get: function () {
            if (!this.products || this.products.length == 0 || this.ui.hidePrices)
                return null;
            var taxPercent = this.config.taxPercent;
            var taxFactor = taxPercent / 100 + 1;
            var subtotal = this.products.reduce(function (s, p) { return s + p.price + p.accessories.reduce(function (as, a) { return as + a.price; }, 0); }, 0);
            var tax = subtotal * taxFactor - subtotal;
            return {
                subTotal: subtotal,
                taxPercent: taxPercent,
                tax: tax,
                grandTotal: subtotal + tax
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "backpanelCodeProperties", {
        get: function () {
            return [
                "backpanelStructure", "material", "backpanelReservedCode",
                "backpanelLength", "backpanelReservedCode2", "backpanelHeight", "graphics"
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "codeProperties", {
        get: function () {
            return tslib_1.__spread(this.mandatoryCodeProperties, this.optionalCodeProperties);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "mandatoryCodeProperties", {
        get: function () {
            return [
                "sink", "worktopLength", "worktopHeight", "sinkHandedness", "edgeProfile", "sinkDistanceX", "worktopWidth"
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "optionalCodeProperties", {
        get: function () {
            return [
                "faucetHoleCode", "extraHoleCode", "material",
                "trap", "hobcutout", "hobcutoutLength", "hobcutoutWidth",
                "hobcutoutCornerRadius", "hobcutoutDistanceX", "hobcutoutDistanceY",
                "m1Structure", "graphics"
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "isCurrentCodeValidWorktopCode", {
        get: function () {
            return this.isValidWorktopCode(this.currentDesignerCode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "isCurrentCodeValidBackpanelCode", {
        get: function () {
            return this.isValidBackpanelCode(this.currentDesignerCode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "designerCodeRegex", {
        get: function () {
            return new RegExp(this.config.designerCodeRegexp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "backpanelCodeRegex", {
        get: function () {
            return new RegExp(this.config.backpanelCodeRegexp);
        },
        enumerable: true,
        configurable: true
    });
    Cart.prototype.isValidWorktopCode = function (code) {
        return this.designerCodeRegex.test(code);
    };
    Cart.prototype.isValidPlanCode = function (code) {
        return code.startsWith("PLAN-");
    };
    Cart.prototype.isValidBackpanelCode = function (code) {
        return this.backpanelCodeRegex.test(code);
    };
    Cart.prototype.trimEnd = function (string, charToRemove) {
        while (string.charAt(string.length - 1) == charToRemove) {
            string = string.substring(0, string.length - 1);
        }
        return string;
    };
    Cart.prototype.fillState = function (code) {
        var e_7, _a;
        var values = [];
        var properties = [];
        if (this.isValidWorktopCode(code)) {
            values = this.designerCodeRegex.exec(code);
            properties = this.codeProperties;
            this.state.mode = "worktop";
        }
        else if (this.isValidBackpanelCode(code)) {
            values = this.backpanelCodeRegex.exec(code);
            properties = this.backpanelCodeProperties;
            this.state.mode = "backpanel";
        }
        if (!values || !properties)
            return;
        values.splice(0, 1); //First item is the full match, don't need it
        for (var i = 0; i < values.length; i++) {
            var property = properties[i];
            var value = values[i];
            if (value && this.trimEnd(value, "0") == '')
                value = null;
            this.state[property] = value;
        }
        var fillableDefaults = ["material", "hobcutout"];
        try {
            for (var fillableDefaults_1 = tslib_1.__values(fillableDefaults), fillableDefaults_1_1 = fillableDefaults_1.next(); !fillableDefaults_1_1.done; fillableDefaults_1_1 = fillableDefaults_1.next()) {
                var p = fillableDefaults_1_1.value;
                if (!this.state[p]) {
                    this.state[p] = "0";
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (fillableDefaults_1_1 && !fillableDefaults_1_1.done && (_a = fillableDefaults_1.return)) _a.call(fillableDefaults_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    Object.defineProperty(Cart.prototype, "currentDesignerCode", {
        get: function () {
            var _this = this;
            if (this.state.mode == "worktop") {
                var mandatoryProperties = this.mandatoryCodeProperties.map(function (p) { return _this.state[p] || _this.state.defaults[p]; }).join("");
                var optionalProperties = this.optionalCodeProperties.map(function (p) { return _this.state[p] || _this.state.defaults[p]; });
                //Remove unnecessary 0's at the end of the code
                for (var i = optionalProperties.length - 1; i >= 0; i--) {
                    if (this.trimEnd(optionalProperties[i], "0") == "") {
                        optionalProperties.pop();
                    }
                    else {
                        break;
                    }
                }
                return mandatoryProperties + optionalProperties.join("");
            }
            else if (this.state.mode == "backpanel") {
                return this.backpanelCodeProperties.map(function (p) { return _this.state[p] || _this.state.defaults[p]; }).join("");
            }
        },
        enumerable: true,
        configurable: true
    });
    Cart.prototype.cancelCurrentDesign = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.resetState();
                this.state.dirty = false;
                this.state.mode = "";
                return [2 /*return*/];
            });
        });
    };
    Cart.prototype.isAdditionalCostProduct = function (code) {
        return code == "P" || (this.config.conditionalAdditionalCostProducts && this.config.conditionalAdditionalCostProducts.filter(function (c) { return c.code == code; }).length > 0);
    };
    Cart.prototype.setDesignerCode = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var designerCode, plan, designableProducts, product, i;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!code)
                            return [2 /*return*/];
                        code = code.trim();
                        designerCode = code;
                        this.resetState();
                        this.resetCart();
                        if (!this.isValidPlanCode(code)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getPlan(code)];
                    case 1:
                        plan = _a.sent();
                        if (!(plan != null)) return [3 /*break*/, 6];
                        designableProducts = plan.products.filter(function (p) { return !_this.isAdditionalCostProduct(p.designerCode); });
                        product = designableProducts[designableProducts.length - 1];
                        if (!(designableProducts.length > 1)) return [3 /*break*/, 5];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < designableProducts.length - 1)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.addPlanProductToCart(designableProducts[i])];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        this.state.accessories = product.accessories ? product.accessories.split(",") : [];
                        designerCode = product.designerCode;
                        _a.label = 6;
                    case 6:
                        this.state.dirty = true;
                        return [4 /*yield*/, this.fillState(designerCode)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Cart;
}());
export { Cart };
var UI = /** @class */ (function () {
    function UI(state, config) {
        this.state = state;
        this.config = config;
        this.helpVisible = false;
        this.minicartVisible = false;
        this.languagesVisible = false;
        this.navigateToStartPopupOpen = false;
        this.exitConfirmed = false;
        this.isTabletView = false;
        this.embedPopupOpen = false;
        this.embedMedia = null;
        this.activeEmbedMedia = null;
        this.activeEmbedVideoUrl = null;
        this.focusedFieldName = "";
    }
    Object.defineProperty(UI.prototype, "self", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    UI.prototype.generateOptionList = function (key, configurationOptions, title) {
        var _this = this;
        return {
            title: title,
            options: configurationOptions.map(function (co) {
                var e_8, _a, e_9, _b;
                var disabled = false;
                var messages = [];
                var warnings = [];
                if (co.rules) {
                    try {
                        for (var _c = tslib_1.__values(co.rules), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var rule = _d.value;
                            var enabled = runExpr({
                                state: _this.state,
                                ui: _this.self,
                                selfKey: key
                            }, rule.expression);
                            if (!enabled) {
                                disabled = true;
                                if (messages.indexOf(rule.resourceKey) == -1)
                                    messages.push(rule.resourceKey);
                            }
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                }
                if (co.warnings) {
                    try {
                        for (var _e = tslib_1.__values(co.warnings), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var warning = _f.value;
                            var hasWarning = runExpr({
                                state: _this.state,
                                ui: _this.self,
                                selfKey: key
                            }, warning.expression);
                            if (hasWarning && warnings.indexOf(warning.resourceKey) == -1) {
                                warnings.push(warning.resourceKey);
                            }
                        }
                    }
                    catch (e_9_1) { e_9 = { error: e_9_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_9) throw e_9.error; }
                    }
                }
                return {
                    value: co.code,
                    text: co.name,
                    link: co.link,
                    image: co.image,
                    embedMedia: co.embedMedia,
                    visible: !_this.state.vertex || co.visibleInVertex,
                    disabled: disabled,
                    warnings: warnings,
                    messages: messages
                };
            })
                .filter(function (o) { return o.visible; })
        };
    };
    Object.defineProperty(UI.prototype, "worktopWidths", {
        get: function () {
            return this.generateOptionList("worktopWidth", this.config.models.worktopWidths, this.t("depth"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopHeights", {
        get: function () {
            return this.generateOptionList("worktopHeight", this.config.models.worktopHeights, this.t("worktopHeight"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopLocations", {
        get: function () {
            return this.generateOptionList("worktopLocation", this.config.models.worktopLocations, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "accessories", {
        get: function () {
            return this.generateOptionList("accessories", this.config.models.accessories, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "edgeProfiles", {
        get: function () {
            return this.generateOptionList("edgeProfile", this.config.models.edgeProfiles, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "materials", {
        get: function () {
            return this.generateOptionList("material", this.config.models.materials, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "faucetHoles", {
        get: function () {
            return this.generateOptionList("faucetHole", this.config.models.faucetHoles, this.t("sinkFaucetHole"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "extraHoles", {
        get: function () {
            return this.generateOptionList("extraHole", this.config.models.extraHoles, this.t("sinkExtraHole"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "extraHoles2", {
        get: function () {
            return this.generateOptionList("extraHole2", this.config.models.extraHoles, this.t("sinkExtraHole"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinks", {
        get: function () {
            return this.generateOptionList("sink", this.config.models.sinks, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelStructures", {
        get: function () {
            return this.generateOptionList("backpanelStructure", this.config.models.backpanelStructures, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelMaterial", {
        get: function () {
            return this.generateOptionList("backpanelMaterial", this.config.models.backpanelMaterial, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutouts", {
        get: function () {
            return this.generateOptionList("hobcutout", this.config.models.hobcutouts, null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "translations", {
        get: function () {
            return this.config.translations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "languages", {
        get: function () {
            var _this = this;
            return this.config.languages.filter(function (l) { return l != _this.language; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "language", {
        get: function () {
            return this.config.language;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hidePrices", {
        get: function () {
            return this.config.hidePrices || this.state.vertex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "chatEnabled", {
        get: function () {
            return this.config.chatEnabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "images", {
        get: function () {
            return this.config.images;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "blocks", {
        get: function () {
            return this.config.blocks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "texts", {
        get: function () {
            return this.config.texts;
        },
        enumerable: true,
        configurable: true
    });
    UI.prototype.toggleHelp = function () {
        this.helpVisible = !this.helpVisible;
    };
    UI.prototype.openEmbedPopup = function (media) {
        this.embedMedia = media;
        this.activeEmbedMedia = media.length > 0 ? media[0] : null;
        this.embedPopupOpen = true;
    };
    Object.defineProperty(UI.prototype, "visibleSelections", {
        get: function () {
            var _this = this;
            var selections = [];
            if (this.state.graphics || this.state.material) {
                var code_1 = this.state.graphics || this.state.material;
                var material = this.materials.options.find(function (o) { return o.value == code_1; });
                selections.push(material);
            }
            if (this.state.accessories) {
                var accessories = this.accessories.options.filter(function (o) { return _this.state.accessories.indexOf(o.value) != -1; });
                selections = tslib_1.__spread(selections, accessories);
            }
            return selections;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutIsInvalid", {
        get: function () {
            return this.state.hobcutout == "1" && this.hobcutoutHasPlacementError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelSelectionsComplete", {
        get: function () {
            return !!this.state.backpanelStructure && !!this.state.backpanelHeight && !!this.state.backpanelLength;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelMaterialSelectionsComplete", {
        get: function () {
            return this.materialSelectionsComplete;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "materialSelectionsComplete", {
        get: function () {
            var selections = [this.state.material];
            return selections.filter(function (s) { return !s; }).length == 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutSelectionsComplete", {
        get: function () {
            if (this.state.hobcutout == "0")
                return true;
            var selections = [this.state.hobcutout, this.state.hobcutoutDistanceY, this.state.hobcutoutDistanceX, this.state.hobcutoutLength, this.state.hobcutoutWidth, !this.hobcutoutIsInvalid];
            return selections.filter(function (s) { return !s; }).length == 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopSelectionsComplete", {
        get: function () {
            var selections = [this.state.worktopLength, this.state.worktopWidth, this.state.worktopHeight, this.state.edgeProfileCode, this.state.worktopLocation];
            return selections.filter(function (s) { return !s; }).length == 0 && this.drawing.ready;
        },
        enumerable: true,
        configurable: true
    });
    UI.prototype.getImageUrl = function (src, maxWidth) {
        return src
            ? src + "?__imgop=1&maxwidth=" + maxWidth
            : null;
    };
    UI.prototype.getBackgroundImageUrl = function (src, maxWidth) {
        return src
            ? "url('" + this.getImageUrl(src, maxWidth) + "')"
            : null;
    };
    Object.defineProperty(UI.prototype, "backpanelStructure", {
        get: function () {
            var _this = this;
            return this.config.models.backpanelStructures.find(function (s) { return s.code == _this.state.backpanelStructure; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelLength", {
        get: function () { return !this.state.backpanelLength ? null : parseInt(this.state.backpanelLength); },
        set: function (value) { this.state.backpanelLength = padLeft(value, 4, "0"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "backpanelHeight", {
        get: function () { return !this.state.backpanelHeight ? null : parseInt(this.state.backpanelHeight); },
        set: function (value) { this.state.backpanelHeight = padLeft(value, 4, "0"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopWidth", {
        get: function () {
            var _this = this;
            return (this.config.models.worktopWidths.find(function (w) { return w.code == _this.state.worktopWidth; }) || {}).width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopHeight", {
        get: function () {
            var _this = this;
            return (this.config.models.worktopHeights.find(function (w) { return w.code == _this.state.worktopHeight; }) || {}).height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "worktopLength", {
        get: function () { return !this.state.worktopLength ? null : parseInt(this.state.worktopLength); },
        set: function (value) { this.state.worktopLength = padLeft(Math.ceil(value / 5) * 5, 4, "0"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceRight", {
        get: function () {
            if (!this.state.hobcutoutDistanceX)
                return null;
            var shortSideDistance = parseInt(this.state.hobcutoutDistanceX);
            if (!this.sink.leftHanded)
                return shortSideDistance;
            return this.worktopLength - this.hobcutoutLength - shortSideDistance;
        },
        set: function (value) {
            var distanceRight = this.getSafeHobcutoutDistanceX(value, false);
            this.state.hobcutoutDistanceX = !this.sink.leftHanded
                ? padLeft(distanceRight, 4, "0")
                : padLeft(this.worktopLength - this.hobcutoutLength - distanceRight, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceRightCenter", {
        get: function () {
            if (!this.state.hobcutoutDistanceX)
                return null;
            return !this.sink.leftHanded
                ? parseInt(this.state.hobcutoutDistanceX) + this.hobcutoutLength / 2
                : this.worktopLength - this.hobcutoutLength - parseInt(this.state.hobcutoutDistanceX) + this.hobcutoutLength / 2;
        },
        set: function (value) {
            var edgeValue = value - this.hobcutoutLength / 2;
            var distanceRight = this.getSafeHobcutoutDistanceX(edgeValue, false);
            this.state.hobcutoutDistanceX = !this.sink.leftHanded
                ? padLeft(distanceRight, 4, "0")
                : padLeft(this.worktopLength - this.hobcutoutLength - distanceRight, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceLeft", {
        get: function () {
            if (!this.state.hobcutoutDistanceX)
                return null;
            var shortSideDistance = parseInt(this.state.hobcutoutDistanceX);
            if (this.sink.leftHanded)
                return shortSideDistance;
            return this.worktopLength - this.hobcutoutLength - shortSideDistance;
        },
        set: function (value) {
            var distanceLeft = this.getSafeHobcutoutDistanceX(value, true);
            this.state.hobcutoutDistanceX = this.sink.leftHanded
                ? padLeft(distanceLeft, 4, "0")
                : padLeft(this.worktopLength - this.hobcutoutLength - distanceLeft, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceLeftCenter", {
        get: function () {
            if (!this.state.hobcutoutDistanceX)
                return null;
            return this.sink.leftHanded
                ? parseInt(this.state.hobcutoutDistanceX) + this.hobcutoutLength / 2
                : this.worktopLength - this.hobcutoutLength - parseInt(this.state.hobcutoutDistanceX) + this.hobcutoutLength / 2;
        },
        set: function (value) {
            var edgeValue = value - this.hobcutoutLength / 2;
            var distanceLeft = this.getSafeHobcutoutDistanceX(edgeValue, true);
            this.state.hobcutoutDistanceX = this.sink.leftHanded
                ? padLeft(distanceLeft, 4, "0")
                : padLeft(this.worktopLength - this.hobcutoutLength - distanceLeft, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    //Collision between sink and hobcutout
    UI.prototype.hasCollision = function (sinkDistanceLeft, hobcutoutDistanceLeft) {
        if (sinkDistanceLeft && this.hobcutoutLength > 0 && this.hobcutoutDistanceLeft > 0 && this.sink.hasDimensions) {
            return (this.hobcutoutDistanceLeft - this.hobcutoutMargins) < (sinkDistanceLeft + this.sink.length) //right side collision
                && (this.hobcutoutDistanceLeft + this.hobcutoutLength + this.hobcutoutMargins) > sinkDistanceLeft; //left side collision
        }
        if (hobcutoutDistanceLeft && this.sink.hasDimensions && this.hobcutoutLength > 0) {
            return (this.sinkDistanceLeft - this.hobcutoutMargins) < (hobcutoutDistanceLeft + this.hobcutoutLength) //right side collision
                && (this.sinkDistanceLeft + this.sink.length + this.hobcutoutMargins) > hobcutoutDistanceLeft; //left side collision
        }
        return false;
    };
    UI.prototype.getSafeHobcutoutDistanceX = function (value, left) {
        var _this = this;
        var desiredDistanceLeft = left ? value : this.worktopLength - this.hobcutoutLength - value;
        if (isNaN(value))
            return 45;
        if (this.hasCollision(null, desiredDistanceLeft)) {
            var availableSpaces = [
                {
                    space: this.sinkDistanceLeft - 45 - this.hobcutoutMargins,
                    left: this.sinkDistanceLeft - this.hobcutoutLength - this.hobcutoutMargins,
                    right: this.sinkDistanceRight + this.sink.length + this.hobcutoutMargins
                },
                {
                    space: this.sinkDistanceRight - 45 - this.hobcutoutMargins,
                    left: this.sinkDistanceLeft + this.sink.length + this.hobcutoutMargins,
                    right: this.sinkDistanceRight - this.hobcutoutLength - this.hobcutoutMargins
                } //right side safe space
            ]
                .filter(function (s) { return s.space >= _this.hobcutoutLength; })
                .sort(function (a, b) { return Math.abs(desiredDistanceLeft - a.left) - Math.abs(desiredDistanceLeft - b.left); });
            if (availableSpaces.length == 0) //There's no space for the hob cutout
                return null;
            return left ? availableSpaces[0].left : availableSpaces[0].right;
        }
        if (!this.sink.hasDimensions || value < 45)
            return Math.max(value, 45);
        if (value > this.worktopLength - this.hobcutoutLength - 45)
            return 45;
        return value;
    };
    Object.defineProperty(UI.prototype, "hobcutoutMargins", {
        get: function () { return 100; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutHasPlacementError", {
        get: function () {
            return this.hasCollision(null, this.hobcutoutDistanceLeft)
                || this.hobcutoutWidth > this.worktopWidth - (45 * 2)
                || (this.hobcutoutLength > 0 && this.hobcutoutWidth > 0
                    && (this.hobcutoutDistanceLeft < 45
                        || !this.hobcutoutDistanceLeft
                        || !this.hobcutoutDistanceFront
                        || this.hobcutoutDistanceRight < 45
                        || this.hobcutoutDistanceFront < 45
                        || this.hobcutoutDistanceBack < 45));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceBack", {
        get: function () { return this.worktopWidth - this.hobcutoutWidth - this.hobcutoutDistanceFront; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutDistanceFront", {
        get: function () { return parseInt(this.state.hobcutoutDistanceY); },
        set: function (value) {
            this.state.hobcutoutDistanceY = isNaN(value)
                ? padLeft(45, 2, "0")
                : padLeft(value, 2, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutWidth", {
        get: function () { return this.state.hobcutoutWidth ? parseInt(this.state.hobcutoutWidth) : null; },
        set: function (value) { this.state.hobcutoutWidth = padLeft(value, 3, "0"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "hobcutoutLength", {
        get: function () { return this.state.hobcutoutLength ? parseInt(this.state.hobcutoutLength) : null; },
        set: function (value) {
            var availableSpaces = [
                (this.sinkDistanceLeft || this.worktopLength) - 45 - (this.sinkDistanceLeft ? this.hobcutoutMargins : 45),
                (this.sinkDistanceRight || this.worktopLength) - 45 - (this.sinkDistanceRight ? this.hobcutoutMargins : 45)
            ];
            var availableSpace = availableSpaces.find(function (s) { return s >= value; });
            var length = availableSpace
                ? value
                : Math.max.apply(Math, tslib_1.__spread(availableSpaces));
            this.state.hobcutoutLength = padLeft(length, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sink", {
        get: function () {
            var _this = this;
            var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
            var sinkConfiguration = sinks.find(function (s) { return s.handedness == _this.state.sinkHandedness; }) || sinks[0];
            //let sinkConfiguration = this.config.models.sinks.find(s => s.code == this.state.sink && s.handedness == this.state.sinkHandedness);
            if (!sinkConfiguration) {
                return {
                    name: null,
                    code: null,
                    handedness: null,
                    description: null,
                    image: null,
                    drawing: null,
                    hasDimensions: false,
                    length: 0,
                    width: 0,
                    fixedDistanceFront: null,
                    sinkCount: 0,
                    height: 0,
                    margins: 40,
                    leftHanded: true,
                };
            }
            return {
                name: sinkConfiguration.name,
                code: sinkConfiguration.code,
                handedness: this.state.sinkHandedness,
                description: sinkConfiguration.description,
                image: sinkConfiguration.image,
                drawing: sinkConfiguration.drawing,
                length: sinkConfiguration.length,
                width: sinkConfiguration.width,
                fixedDistanceFront: sinkConfiguration.fixedDistanceFront,
                sinkCount: sinkConfiguration.sinkCount,
                height: sinkConfiguration.height,
                hasDimensions: sinkConfiguration.length > 0 && sinkConfiguration.width > 0,
                margins: 40,
                leftHanded: this.state.sinkHandedness == "V",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkIsValid", {
        get: function () { return (!this.state.sink || this.sinkValidationMessages.length == 0); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkHasPlacementError", {
        get: function () {
            return this.hasCollision(this.sinkDistanceLeft, null)
                || !this.sinkIsValid
                || (this.sink.hasDimensions
                    && (this.sinkDistanceLeft < this.sink.margins || this.sinkDistanceRight < this.sink.margins));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkValidationMessages", {
        get: function () {
            var _this = this;
            var e_10, _a;
            var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
            var sinkConfiguration = sinks.find(function (s) { return s.handedness == _this.state.sinkHandedness; }) || sinks[0];
            var messages = [];
            if (sinkConfiguration && sinkConfiguration.rules) {
                try {
                    for (var _b = tslib_1.__values(sinkConfiguration.rules), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var rule = _c.value;
                        var enabled = runExpr({
                            state: this.state,
                            ui: this.self,
                            selfKey: "sink"
                        }, rule.expression);
                        if (!enabled && messages.indexOf(rule.resourceKey) == -1) {
                            messages.push(rule.resourceKey);
                        }
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
            return messages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkSelectionsComplete", {
        get: function () {
            if (this.state.sink && !this.sink.length)
                return true;
            return [this.state.sink, this.state.sinkDistanceX, this.state.faucetHole, this.state.extraHole, this.state.extraHole2, this.sinkIsValid, !this.sinkHasPlacementError].filter(function (s) { return !s; }).length == 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceFront", {
        get: function () { return this.sink.fixedDistanceFront || ((this.worktopWidth - this.sink.width) / 2); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceBack", {
        get: function () { return (this.worktopWidth - this.sink.width - this.sinkDistanceFront); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceLeft", {
        get: function () {
            if (!this.state.sinkDistanceX)
                return null;
            return this.sink.leftHanded
                ? parseInt(this.state.sinkDistanceX)
                : this.worktopLength - this.sink.length - parseInt(this.state.sinkDistanceX);
        },
        set: function (value) {
            var _this = this;
            var distanceLeft = this.getSafeSinkDistanceX(value, true);
            if (this.state.sinkHandedness != "V") {
                var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
                if (sinks.length == 1) {
                    this.state.sinkHandedness = "V";
                }
            }
            this.state.sinkDistanceX = this.state.sinkHandedness == "V"
                ? padLeft(distanceLeft, 4, "0")
                : padLeft(this.worktopLength - this.sink.length - distanceLeft, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceLeftCenter", {
        get: function () {
            if (!this.state.sinkDistanceX)
                return null;
            return this.sink.leftHanded
                ? parseInt(this.state.sinkDistanceX) + this.sink.length / 2
                : this.worktopLength - this.sink.length - parseInt(this.state.sinkDistanceX) + this.sink.length / 2;
        },
        set: function (value) {
            var _this = this;
            var edgeValue = value - this.sink.length / 2;
            var distanceLeft = this.getSafeSinkDistanceX(edgeValue, true);
            if (this.state.sinkHandedness != "V") {
                var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
                if (sinks.length == 1) {
                    this.state.sinkHandedness = "V";
                }
            }
            this.state.sinkDistanceX = this.state.sinkHandedness == "V"
                ? padLeft(distanceLeft, 4, "0")
                : padLeft(this.worktopLength - this.sink.length - distanceLeft, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceRight", {
        get: function () {
            if (!this.state.sinkDistanceX)
                return null;
            return !this.sink.leftHanded
                ? parseInt(this.state.sinkDistanceX)
                : this.worktopLength - this.sink.length - parseInt(this.state.sinkDistanceX);
        },
        set: function (value) {
            var _this = this;
            var distanceRight = this.getSafeSinkDistanceX(value, false);
            if (this.state.sinkHandedness != "O") {
                var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
                if (sinks.length == 1) {
                    this.state.sinkHandedness = "O";
                }
            }
            this.state.sinkDistanceX = this.state.sinkHandedness != "V"
                ? padLeft(distanceRight, 4, "0")
                : padLeft(this.worktopLength - this.sink.length - distanceRight, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "sinkDistanceRightCenter", {
        get: function () {
            if (!this.state.sinkDistanceX)
                return null;
            return !this.sink.leftHanded
                ? parseInt(this.state.sinkDistanceX) + this.sink.length / 2
                : this.worktopLength - this.sink.length - parseInt(this.state.sinkDistanceX) + this.sink.length / 2;
        },
        set: function (value) {
            var _this = this;
            var edgeValue = value - this.sink.length / 2;
            var distanceRight = this.getSafeSinkDistanceX(edgeValue, false);
            if (this.state.sinkHandedness != "O") {
                var sinks = this.config.models.sinks.filter(function (s) { return s.code == _this.state.sink; });
                if (sinks.length == 1) {
                    this.state.sinkHandedness = "O";
                }
            }
            this.state.sinkDistanceX = this.state.sinkHandedness != "V"
                ? padLeft(distanceRight, 4, "0")
                : padLeft(this.worktopLength - this.sink.length - distanceRight, 4, "0");
        },
        enumerable: true,
        configurable: true
    });
    UI.prototype.getAvailableSinkSpace = function () {
        if (!this.state.hobcutout || this.state.hobcutout == "0" || this.hobcutoutLength <= 0 || this.hobcutoutWidth <= 0 || !this.hobcutoutDistanceLeft || this.hobcutoutDistanceLeft <= 0)
            return this.worktopLength;
        return Math.max(this.hobcutoutDistanceLeft - this.sink.margins - this.hobcutoutMargins, this.hobcutoutDistanceRight - this.sink.margins - this.hobcutoutMargins);
    };
    UI.prototype.getSafeSinkDistanceX = function (value, left) {
        var _this = this;
        var desiredDistanceLeft = left ? value : this.worktopLength - this.sink.length - value;
        if (isNaN(value))
            return this.sink.margins;
        if (this.hasCollision(desiredDistanceLeft, null)) {
            var availableSpaces = [
                {
                    space: this.hobcutoutDistanceLeft - this.sink.margins - this.hobcutoutMargins,
                    left: this.hobcutoutDistanceLeft - this.sink.length - this.hobcutoutMargins,
                    right: this.hobcutoutDistanceRight + this.hobcutoutLength + this.hobcutoutMargins
                },
                {
                    space: this.hobcutoutDistanceRight - this.sink.margins - this.hobcutoutMargins,
                    left: this.hobcutoutDistanceLeft + this.hobcutoutLength + this.hobcutoutMargins,
                    right: this.hobcutoutDistanceRight - this.hobcutoutLength - this.hobcutoutMargins
                } //right side safe space
            ]
                .filter(function (s) { return s.space >= _this.sink.length; })
                .sort(function (a, b) { return Math.abs(desiredDistanceLeft - a.left) - Math.abs(desiredDistanceLeft - b.left); });
            if (availableSpaces.length == 0) //There's no space for the hob cutout
                return null;
            return Math.ceil((left ? availableSpaces[0].left : availableSpaces[0].right) / 5) * 5;
        }
        if (this.hobcutoutLength == 0 || value < this.sink.margins)
            return Math.max(Math.ceil(value / 5) * 5, this.sink.margins);
        if (value > this.worktopLength - this.sink.length - this.sink.margins)
            return this.sink.margins;
        return Math.ceil(value / 5) * 5;
    };
    UI.prototype.clearFocusedField = function () {
        this.focusedFieldName = null;
    };
    Object.defineProperty(UI.prototype, "drawing", {
        get: function () {
            var _this = this;
            var containerLength = 5000;
            var containerWidth = 1500;
            var drawingReady = [this.worktopWidth, this.worktopHeight, this.worktopLength]
                .filter(function (d) { return d == null || isNaN(d) || d == 0; }).length == 0;
            var hobcutout = this.config.models.hobcutouts.find(function (o) { return o.code == _this.state.hobcutout; });
            var distances = [];
            var gapElement = null;
            //Sink length bar
            if (this.sink.hasDimensions) {
                distances.push({
                    cssPositionLeft: this.sinkDistanceLeft / this.worktopLength * 100,
                    positionLeftValue: this.sinkDistanceLeft,
                    cssWidth: this.sink.length / this.worktopLength * 100,
                    widthValue: this.sink.length
                });
            }
            //Hob cutout bar
            if (this.state.hobcutout == "1" && this.hobcutoutLength > 0) {
                distances.push({
                    cssPositionLeft: this.hobcutoutDistanceLeft / this.worktopLength * 100,
                    positionLeftValue: this.hobcutoutDistanceLeft,
                    cssWidth: this.hobcutoutLength / this.worktopLength * 100,
                    widthValue: this.hobcutoutLength
                });
            }
            if (distances.length > 0) {
                var sortedDistances = distances.sort(function (a, b) { return a.positionLeftValue - b.positionLeftValue; });
                var lastDistanceElement = sortedDistances[sortedDistances.length - 1];
                var firstDistanceElement = sortedDistances[0];
                //Gap between sink and hobcutout
                if (distances.length == 2) {
                    gapElement = {
                        cssPositionLeft: firstDistanceElement.cssPositionLeft + firstDistanceElement.cssWidth,
                        positionLeftValue: firstDistanceElement.positionLeftValue + firstDistanceElement.widthValue,
                        cssWidth: (lastDistanceElement.positionLeftValue - (firstDistanceElement.positionLeftValue + firstDistanceElement.widthValue)) / this.worktopLength * 100,
                        widthValue: lastDistanceElement.positionLeftValue - (firstDistanceElement.positionLeftValue + firstDistanceElement.widthValue)
                    };
                    distances.push(gapElement);
                }
                //Left edge of worktop to left edge of sink or hobcutout, which ever is leftmost
                distances.push({
                    cssPositionLeft: 0,
                    positionLeftValue: 0,
                    cssWidth: firstDistanceElement.cssPositionLeft,
                    widthValue: firstDistanceElement.positionLeftValue
                });
                var rightEdgeWidthValue = (this.worktopLength - (lastDistanceElement.positionLeftValue + lastDistanceElement.widthValue));
                //Right edge of worktop to right edge of sink or hobcutout, which ever is rightmost
                distances.push({
                    cssPositionLeft: lastDistanceElement.cssPositionLeft + lastDistanceElement.cssWidth,
                    positionLeftValue: this.worktopLength - (lastDistanceElement.positionLeftValue + lastDistanceElement.widthValue),
                    cssWidth: rightEdgeWidthValue / this.worktopLength * 100,
                    widthValue: rightEdgeWidthValue
                });
            }
            return {
                ready: drawingReady,
                containerWidth: containerWidth,
                containerLength: containerLength,
                worktopWidth: this.worktopWidth / containerWidth * 100,
                worktopHeight: (17 + (this.worktopHeight - 20) / 2) / 2,
                worktopLength: this.worktopLength / containerLength * 100,
                sinkLength: this.sink.length / this.worktopLength * 100,
                sinkWidth: this.sink.width / this.worktopWidth * 100,
                sinkDistanceLeft: this.sinkDistanceLeft / this.worktopLength * 100,
                sinkDistanceLeftCenter: this.sinkDistanceLeftCenter / this.worktopLength * 100,
                sinkDistanceRight: this.sinkDistanceRight / this.worktopLength * 100,
                sinkDistanceRightCenter: this.sinkDistanceRightCenter / this.worktopLength * 100,
                sinkDistanceFront: this.sinkDistanceFront / this.worktopWidth * 100,
                sinkDistanceBack: this.sinkDistanceBack / this.worktopWidth * 100,
                sinkDrawing: this.sink.drawing,
                gapDistanceLeft: gapElement ? gapElement.cssPositionLeft : 0,
                gapLength: gapElement ? gapElement.cssWidth : 0,
                gapValue: gapElement ? gapElement.widthValue : 0,
                hobcutoutWidth: this.hobcutoutWidth / this.worktopWidth * 100,
                hobcutoutLength: this.hobcutoutLength / this.worktopLength * 100,
                hobcutoutDistanceFront: this.hobcutoutDistanceFront / this.worktopWidth * 100,
                hobcutoutDistanceBack: this.hobcutoutDistanceBack / this.worktopWidth * 100,
                hobcutoutDistanceLeft: this.hobcutoutDistanceLeft / this.worktopLength * 100,
                hobcutoutDistanceLeftCenter: this.hobcutoutDistanceLeftCenter / this.worktopLength * 100,
                hobcutoutDistanceRight: this.hobcutoutDistanceRight / this.worktopLength * 100,
                hobcutoutDistanceRightCenter: this.hobcutoutDistanceRightCenter / this.worktopLength * 100,
                hobcutoutDrawing: hobcutout ? hobcutout.drawing : null,
                safetyAreaWidth: (this.worktopWidth - 30) / this.worktopWidth * 100,
                safetyAreaLength: (this.sink.length + 50) / this.worktopLength * 100,
                safetyAreaLeft: (this.sinkDistanceLeft - 25) / this.worktopLength * 100,
                summaryDistances: distances
            };
        },
        enumerable: true,
        configurable: true
    });
    UI.prototype.t = function (key) {
        return this.translations[key] || "[" + key + "]";
    };
    return UI;
}());
export { UI };
var defaultStore = {
    configuration: null,
    ui: null,
    cart: null,
    ready: false,
    state: null
};
var storeVm = new Vue({ data: { store: defaultStore } });
export var store = storeVm.$data["store"];
